// extracted by mini-css-extract-plugin
module.exports = {"icon":"MoreButton_icon__2CYky"};